import { Route, Routes } from 'react-router-dom'

import routes from '~/configs/routes'
import NotFound from '~/pages/not-found'

import PrivateRoute from './PrivateRoute'

const PageRoutes = () => {
  return (
    <Routes>
      {routes.map((route, index) => {
        const { path, isPrivate, component: Component } = route
        return (
          <Route
            key={index}
            path={path}
            element={
              isPrivate ? (
                <PrivateRoute>
                  <Component />
                </PrivateRoute>
              ) : (
                <Component />
              )
            }
          />
        )
      })}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default PageRoutes
